document.addEventListener("DOMContentLoaded", () => {

  if (typeof gsap === "undefined") return;

  gsap.from(".reveal-subtitle", {
    y: 50,
    opacity: 0,
    duration: 0.8
  });

  gsap.from(".reveal-title", {
    y: 80,
    opacity: 0,
    duration: 1,
    delay: 0.2
  });

  gsap.from(".reveal-description", {
    y: 50,
    opacity: 0,
    duration: 1,
    delay: 0.4
  });

  gsap.from(".reveal-button", {
    scale: 0.8,
    opacity: 0,
    duration: 0.8,
    delay: 0.6
  });
  const product = document.querySelector(".hero-product img");

if(product){

document.addEventListener("mousemove",(e)=>{

const x=(window.innerWidth/2-e.clientX)/35;
const y=(window.innerHeight/2-e.clientY)/35;

gsap.to(product,{
rotationY:-x,
rotationX:y,
duration:.6
});

});

}

if(product){

gsap.to(product,{
y:-20,
repeat:-1,
yoyo:true,
duration:2,
ease:"power1.inOut"
});

}

});